window.onload = new function () {

	resizeWindow();

	template();

	//Slick Slider
	$('.sym-slides').slick();
	$('.separate-slides').slick({
		'arrows': true,
	});

	$('.slick-rooms').slick({
		dots: false,
		infinite: true,
		autoplay: false,
		fade: true,
		lazyLoad: 'ondemand',
		accessibility: false
	});

	$('.sym-slides-list').slick({
        accessibility: false,
        autoplay: true,
		autoplaySpeed: 3000
    });

}
	(function () {

		setTimeout( () => {
			$( "[name=_token]" ).val( $( "[name=_token]" ).val().replace( " ", "" ) )
		}, 5000 );

		$(document).ready(function () {
			//menus
			$('.btn-menu-ancla').on('click', function (e) {
				var el = $(e.target.getAttribute('href'));
				var elOffset = el.offset().top;
				var elHeight = el.height();
				var windowHeight = $(window).height();
				var offset;

				if (elHeight < windowHeight) {
					offset = elOffset - ((windowHeight / 4) - (elHeight / 1.5));
				}
				else {
					offset = elOffset;
				}
				var speed = 700;
				$('html, body').animate({ scrollTop: offset }, speed);
			});
			$(function () {


				$(".fancybox-gall").fancybox({
					openEffect: 'none',
					closeEffect: 'none'
				});

				$('#accordion').accordion({

					collapsible: true,
					active: false,
					animate: 200
				});
				$('.btn1').click(function (e) {
					e.preventDefault();
					$('#menus_citrus_food').click();
				});
				$('.btn2').click(function (e) {
					e.preventDefault();
					$('#menus_citrus_cocktails').click();
				});
				$('.btn3').click(function (e) {
					e.preventDefault();
					$('#menus_citrus_wine').click();
				});
				$('.btn4').click(function (e) {
					e.preventDefault();
					$('#menus_citrus_beer').click();
				});

				$('.btn1').click(function (e) {
					e.preventDefault();
					$('#menus_living_cocktails').click();
				});
				$('.btn2').click(function (e) {
					e.preventDefault();
					$('#menus_living_wine').click();
				});
				$('.btn3').click(function (e) {
					e.preventDefault();
					$('#menus_living_beer').click();
				});
				$('.btn4').click(function (e) {
					e.preventDefault();
					$('#menus_living_champagne').click();
				});
				$('.btn5').click(function (e) {
					e.preventDefault();
					$('#menus_living_food').click();
				});
				$('.btn6').click(function (e) {
					e.preventDefault();
					$('#menus_living_breakfast').click();
				});
				// $('.btn7').click(function (e) {
				// 	e.preventDefault();
				// 	$('#menus_living_thursday').click();
				// });



			});

			//target in pages
			var url = window.location.href;

			if (url.indexOf('#') > -1) {
				var target = url.split('#')[1];
				$('body, html').animate({ scrollTop: $('#' + target).offset().top - 200 },
					1200, 'easeOutExpo');
			}




			// Main Nav Dropdown
			$("#primary-nav li").hover(function () {
				$(this).addClass("hover");
				$('ul.submenu', this).fadeIn(200);
			}, function () {
				$(this).removeClass("hover");
				$('ul.submenu', this).fadeOut(200);
			});

			$(window).resize(function () {

				if (document.getElementsByClassName('instagram-slide').length > 0) {
					let instagramW = document.getElementsByClassName('instagram-slide')[0].clientWidth;
					$('.instagram-slide a').each(function () {
						let itemW = (instagramW / 5) + 'px';
						$(this).css("width", itemW, "height", itemW);
					});
				}


				var boxInsta = document.getElementsByClassName('boxImageInstagram-js');
				for (var i = 0; i < boxInsta.length; i++) {
					var widthBox = boxInsta[i].offsetWidth;
					boxInsta[i].style.height = widthBox + "px";
				}

				setTimeout(function () {
					equalize();
				}, 500);
			});

			if (window.location.href.indexOf("spa") > -1 && window.location.href.indexOf("charleston-spa") == -1) {
				var x = window.matchMedia("(max-width: 991px)");
				if (x.matches) {
					var element = document.getElementsByClassName("equalize");
					element.classList.remove("equalize");
				}
			}

			$(".checkmark").insertAfter($('.gdpr input'));
			$("#email-signup input[name='tex_nickname']").addClass('hidden');
			$('iframe[name="chat-widget"]').attr('border', '1');
			$('iframe[name="chat-widget"]').attr('title', 'chat-widget');

			//Restaurant menus copy title product
			if(document.querySelectorAll('.content--item .content-menu > h3')){
				document.querySelectorAll('.content--item .content-menu > h3').forEach(function(elm){
					if(elm.textContent.indexOf('_') != -1){
						let text = elm.textContent.split('_');
						elm.innerHTML = `${ text[0] } <span>${ text[1] }</span>`;
					}
				});
			}


			//Close Banner Hurricane
			$('.close-icon').click(function () {
				$('.hurricane').fadeOut(200);
			});


			var page = window.location.href;
			if (page.indexOf("spa", "meetings-and-events", "drinks-dining") > -1) {
				if (!Cookies.get('condBanner')) {
					$('#cond-nast-popup').fadeIn();
					Cookies.set('condBanner', 1, { 'path': '/' });
				}
			}

			if (page.indexOf("spa", "charleston-spa") > -1) {
				if ($("#content-popin").length > 0) {
					$('#content-popin').addClass("hide-right-popin");
					$('.box-content-popin').addClass("open");
					$('.arrow').addClass("open");
				}
			}

			$('.read-details').click(function (explore) {
				explore.preventDefault();

				let self = $(this);
				let nextcontent = self.next('.hidden-info');
				if (!self.hasClass('open')) {

					$('.read-details').each(function () {

						let button = $(this);
						let nextS = button.next('.hidden-info');
						if (button.hasClass('open')) {
							button.removeClass('open');
							nextS.slideUp();
						}
					});
					self.addClass('open');
					nextcontent.slideDown();
				} else {
					self.removeClass('open');
					nextcontent.slideUp();

				}

			});

			// if(document.getElementById('home-instagram__gallery')){
			// 	if(document.getElementsByClassName('fieldshop').length > 0){
			// 		instagramAjaxFeed('ggfieldshop',5,'#home-instagram__gallery',320,'.instagram-block');
			// 	} else {
			// 		instagramAjaxFeed('thedewberrycharleston',5,'#home-instagram__gallery',320,'.instagram-block');
			// 	}
			// }


			$('#email-signup label').addClass('hidden');

			//Acts when scroll down page.
			$(window).scroll(function (event) {
				if ($('.book-btn').hasClass('open')) {
					hideBooking();
				}
			});

			//Home page scroll down arrow. If present.
			$('.arrow-home').click(function (event) {
				$('body, html').animate({
					scrollTop: $(window).height() - $('header').outerHeight() * 2
				},
					800, 'easeOutExpo');
			});

			$('.listMenu li a').click(function () {
				if (!$(this).hasClass('external')) {
					var target = $(this).attr('href');
					$('.listMenu a').removeClass('active');
					$(this).addClass('active');

					$('.info-services').fadeOut(200);
					$(target).fadeIn(250);
					return false;
				}
			});
			$('#guest-info link[rel="stylesheet"]').remove();

			//Adjust Height in last box spa page
			var page = window.location.href;
			if (page.indexOf("spa") || page.indexOf("about-the-dewberry") > -1) {
				$('.slideTrigger').on('click', function () {
					var button = $(this);
					var extraContent = button.next().height();
					var heightParent = button.closest("li").height();
					if (button.hasClass("active")) {
						button.text("Read More");
						button.removeClass("more");
						button.closest("li").animate({ height: heightParent - extraContent - button.height() }, 500);
					} else {
						button.text("Read Less");
						button.addClass("more");
						button.closest("li").animate({ height: heightParent + extraContent + button.height() }, 500);
					}
				});
			}
			if (page.indexOf("hotel-update")) {
				$('.slideTrigger').on('click', function () {
					var button = $(this);
					var extraContent = button.prev();
					if (button.hasClass("active")) {
						button.text("READ LESS");
						button.addClass("more");
						extraContent.show();
					} else {
						button.text("READ MORE");
						button.removeClass("more");
						extraContent.hide();
					}
				});
			}
			//Booking widget
			 /*$('.book-btn').click(showBooking); */

			//Event Tracking
			$('.book-now').on('click', function () {
				if (typeof ga == 'function') ga('send', 'event', 'reservations', 'click', 'book now');
			});
			$('.bookNow').on('click', function () {
				if (typeof ga == 'function') ga('send', 'event', 'header widget', 'click', 'book now');
			});

			$('.third-nav-4 a').on('click', function () {
				if (typeof ga == 'function') ga('send', 'event', 'CareerLink', 'click', 'Click');
			});

			//Check in and check out datepicker for booking engine
			$("#CheckIn").datepicker({
				rangeSelect: true,
				changeMonth: false,
				numberOfMonths: 1,
				// beforeShow: selectDays,
				autoclose: true,
				minDate: 0,
				beforeShow: function(input, inst) {
					// Personaliza la posición del calendario
					console.log(inst);
					setDatepickerPos(input, inst)
					
				},
				onSelect: function (selectedDate) {
					let getDate = $(this).datepicker('getDate');
					let newDate = new Date(getDate.getTime());
					newDate.setDate(newDate.getDate() + 2);
					$("#CheckOut").datepicker("setDate", newDate);
					$("#CheckOut").datepicker("option", "minDate", selectedDate);
				},
				onClose: function (dateText, inst) {
					$("#CheckOut").focus();
				}
			});
			$("#CheckOut").datepicker({
				rangeSelect: true,
				changeMonth: false,
				numberOfMonths: 1,
				//beforeShow: selectDays,
				beforeShow: function(input, inst) {
					// Personaliza la posición del calendario
					console.log(inst);
					setDatepickerPos(input, inst)
					
				},
				onSelect: function (selectedDate) {
					$("#CheckIn").datepicker("option", "maxDate", selectedDate).addClass("ui-state-active");
				},
			});

			$('.pop-up .close').click(function () {
				$('.pop-up').fadeOut(400, function () {
					$(".pop-up").remove();
					// $('body#home #secondary-nav').removeClass('spanomination');
				});

			});
			// Date form spa
			$("#dateSpa").datepicker({
				rangeSelect: true,
				changeMonth: false,
				numberOfMonths: 1,
				minDate: 0,
			});

			function setDatepickerPos(input, inst) {
				var rect = input.getBoundingClientRect();
				// use 'setTimeout' to prevent effect overridden by other scripts
				setTimeout(function () {
						var scrollTop = $("body").scrollTop();
					inst.dpDiv.css({ top: rect.top + input.offsetHeight + scrollTop });
				}, 0);
			}

			//conde pop in class condePopin in footer
			$('.condePopin').click(function () {
				ga('send', 'event', 'popup', 'click', 'cnt2019', 'cnt2019');
			});

			$('#email-signup a#emailSignupCustom').click(function () {

				var firstname = $('input[name=first_name_signup]');
				var lastname = $('input[name=last_name_signup]');
				var email_address = $('#email-signup input[name=email_address_signup]');
				var lang = $('#email-signup input[name=lang]');
				var data = 'firstname=' + firstname.val() + '&lastname=' + lastname.val() + '&email_address=' + email_address.val() + '&list_id=' + list_id + '&language=' + lang.val();

				$url = $(email_address).attr('data-url');

				//start the ajax
				$.ajax({
					url: site_url + "ajax/email-signup.php",
					type: "GET",
					data: data,
					cache: false,
					success: function (html) {

						var customMessage = ($("#customMessage").length) ? $("#customMessage").val() : '';
						customMessage = (customMessage == '') ? "Thank you for your interest." : customMessage;

						if (html == 1) {
							//Success
							$('#email-signup #email-error').addClass('success');
							if ($('body').hasClass('lang-es')) {
								$('#email-signup #email-error').html('<p>' + customMessage + '</p>');
							} else {
								$('#email-signup #email-error').html('<p>' + customMessage + '</p>');
							}
							$('#email-signup #email-error').fadeIn('slow');
							$('#email-signup input').fadeOut('slow');
							$('#email-signup label').fadeOut('slow');
							$('#email-signup a#emailSignup').fadeOut('slow');
							setTimeout(function () {
								$('#email-signup #email-error').fadeOut('slow');
								$('#email-signup input').fadeIn('slow');
								$('#email-signup input').val('');
								$('#email-signup label').fadeIn('slow');
								$('#email-signup a#emailSignup').fadeIn('slow');
							}, 5000);
							if (typeof (ga) == "function") {
								ga('send', 'event', 'form', 'click', 'specials');
							}
							if (typeof (dataLayer.push) == "function") {
								//var dataLayer = [];
								dataLayer.push({ 'event': 'email_signup' });
								console.log(data);
							}
						} else {
							//Error
							$('#email-signup #email-error').html(html);
							$('#email-signup #email-error').fadeIn('slow');
						}
					}
				});
				return false;
			});

		});
		// ADA
		$('a.facebook').attr('aria-label','See our Facebook');
		$('a.instagram').attr('aria-label','See our Instagram');
		$('a.tripadvisor').attr('aria-label','See our tripadvisor');



		//vanilla JS fancybox
		if(document.getElementsByClassName('lightbox').length > 0){
			let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
			let allLightboxesLength = allLightboxes.length;

			for(let j = 0; j < allLightboxesLength; j++ ){
				allLightboxes[j].addEventListener('click', function(e){
					e.preventDefault();
					let currentTarget = this.getAttribute('href').split('#')[1];
					if(!document.getElementById(currentTarget).classList.contains('open')){
						document.getElementById(currentTarget).classList.add('open')
					} else {
						document.getElementById(currentTarget).classList.remove('open')
					}
				});
			}

			let allLightcloses = document.getElementsByClassName('js-lightboxclose');
			let allLightclosesLength = allLightcloses.length;

			for(let j = 0; j < allLightclosesLength; j++ ){
				allLightcloses[j].addEventListener('click', function(e){
					e.preventDefault();
					let currentTarget = this.parentElement.parentElement.id;
					if(!document.getElementById(currentTarget).classList.contains('open')){
						document.getElementById(currentTarget).classList.add('open')
					} else {
						document.getElementById(currentTarget).classList.remove('open')
					}
				});
			}
		}
		setTimeout(() => {	
			$(".cc-menu .ui-accordion-header:first").click()
		}, 500);

	}());
function resizeWindow() {


	if (document.getElementsByClassName('instagram-slide').length > 0) {
		let instagramW = document.getElementsByClassName('instagram-slide')[0].clientWidth;
		let allinstagramImg = document.getElementsByClassName('instagram-slide')[0].getElementsByTagName('a');
		let allinstagramImgLength = allinstagramImg.length;
		for (let t = 0; t < allinstagramImgLength; t++) {
			let itemW = instagramW / 5;
			allinstagramImg[t].style.width = itemW + 'px';
			allinstagramImg[t].style.height = itemW + 'px';
		}
	}


	var boxInsta = document.getElementsByClassName('boxImageInstagram-js');
	for (var i = 0; i < boxInsta.length; i++) {
		var widthBox = boxInsta[i].offsetWidth;
		boxInsta[i].style.height = widthBox + "px";
	}

	setTimeout(function () {
		equalize();
	}, 500);

}

function template() {
	var items = $('.cntn-list li, #specials li');

	items.each(function () {
		var boxHeight = $(this).find('.unit-content').height();
	});


	var trigger = $('.slideTrigger');
	slideNextContent1(trigger, 'active');

	function slideNextContent1(btn, className) {
		btn.click(function (event) {
			var $this = $(this);
			event.preventDefault();
			$this.toggleClass(className);
			$this.next().slideToggle();
		});
	}

}
function showBooking() {
	$('.book-btn').addClass('open');
	$('.booking-block').slideDown(300);
	$('.book-btn').unbind('click');
	$('.book-btn').click(hideBooking);
}
function hideBooking() {
	$('.book-btn').removeClass('open');
	$('.booking-block').slideUp(300);
	$('.book-btn').unbind('click');
	$('.book-btn').click(showBooking);
}




